import logo from 'src/images/frida_logo.png';
import styles from './Logo.module.css';

const Logo = () => (
  <div className={styles.logoContainer}>
    <img src={logo} alt="Frida Logo" className={styles.logo} />
    <span className={styles.logoText}>Frida Central</span>
  </div>
);

export { Logo };
